import { configuration } from '../../utils/configuration';
import { http } from '../http';

export const handlePaymentSubmit = async (
  amount: string,
  locationId: number,
  isR1Invoice = false,
  transactionType?: 'PURCHASE' | 'PREAUTHORIZATION',
  card?: { saveCard?: boolean; savedCardId?: number | null },
): Promise<void> => {
  const paymentOrderData = await http.createPaymentOrder({
    amount,
    locationId: locationId,
    clientUrl: configuration.FRONTEND_URL || '',
    isR1Invoice: isR1Invoice,
    ...(transactionType ? { transactionType } : {}),
    // Saved cards: either pay with one, or ask the gateway to keep the new one.
    ...(card?.savedCardId ? { savedCardId: card.savedCardId } : {}),
    ...(!card?.savedCardId && card?.saveCard ? { saveCard: true } : {}),
  });

  const checkout = paymentOrderData.checkout;
  if (checkout && checkout.flow !== 'FORM_POST') {
    // CLIENT_COMPONENT (Monri Components) / REDIRECT (Stripe) flows get their
    // own handling when those providers ship.
    throw new Error(`Unsupported checkout flow: ${checkout.flow}`);
  }

  // The backend decides the gateway and form fields per location; the legacy
  // field build below only covers backends that predate the checkout payload.
  const actionUrl =
    (checkout?.flow === 'FORM_POST' && checkout.actionUrl) ||
    `${configuration.WS_PAY_URL}/authorization.aspx`;
  const fields: Record<string, string> =
    checkout?.flow === 'FORM_POST'
      ? checkout.fields
      : {
          ShopID: paymentOrderData.shopId,
          ShoppingCartID: Number(paymentOrderData.id).toString(),
          Version: paymentOrderData.version,
          TotalAmount: paymentOrderData.amount,
          Signature: paymentOrderData.signature,
          ReturnURL: paymentOrderData.returnURL,
          ReturnErrorURL: paymentOrderData.returnErrorURL,
          CancelURL: paymentOrderData.cancelURL,
        };

  const submitForm = document.createElement('form');
  submitForm.method = 'POST';
  submitForm.action = actionUrl;

  Object.entries(fields).map(([key, value]) => {
    const customInput = document.createElement('input');
    customInput.type = 'hidden';
    customInput.name = key;
    customInput.value = value;
    submitForm.appendChild(customInput);
  });
  document.body.appendChild(submitForm);
  submitForm.submit();
};
